/** @file Selection store: selected bones, slots, mesh vertices and keyframes (SelectionSlice). */
import { createStore } from 'zustand/vanilla';
import type { SelectionSlice } from './types';

/** Vanilla store; cleared whenever another project opens. */
export const selectionStore = createStore<SelectionSlice>()(() => ({ bones: [], slots: [], vertices: [], keys: [] }));
